var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5C8 1.94772 8.44772 1.5 9 1.5H13C13.5523 1.5 14 1.94772 14 2.5V3.5H17.5C18.3284 3.5 19 4.17157 19 5V18.5C19 19.3284 18.3284 20 17.5 20H4.5C3.67157 20 3 19.3284 3 18.5V5C3 4.17157 3.67157 3.5 4.5 3.5H8V2.5ZM9.5 2.5V3.5H12.5V2.5H9.5ZM4.5 5H17.5V18.5H4.5V5ZM6 7H16V8.5H6V7ZM6 11H16V12.5H6V11ZM6 15H12V16.5H6V15Z",
    fill: "#7367F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyPurpleIcon);
export default __webpack_public_path__ + "static/media/survey-purple-icon.1c0709974f25785f1c1b0c53d106eaae.svg";
export { ForwardRef as ReactComponent };